
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index7HhGW2nkM1fyUVfQ2gB3jV5vrejVpUVSmrMI1S7acOgMeta } from "/app/cms_public/pages/index.vue?macro=true";
import { default as indexcZpig54WY76yIgmZpWSl9SR35DaABHCLyGar7vIIRfMMeta } from "/app/cms_public/pages/news/index.vue?macro=true";
import { default as indexkAsNXC8Ope42uXSfNGl6KVcZHPWXX8e2U42yF1IX6jIMeta } from "/app/cms_public/pages/staff/index.vue?macro=true";
import { default as indexkokLDV_45K0MXqb9I5JpsQlsxixJAH5DueQy4qWFFA8uwMeta } from "/app/cms_public/pages/dining/index.vue?macro=true";
import { default as indexhfVkcXctmujg0Dm1j0Ij0qu0RpPtKrrkB6sMG_N6lrsMeta } from "/app/cms_public/pages/events/index.vue?macro=true";
import { default as indexxAsSiZqMlLS5HwWjkf2Ep4GeEt_45_45xi69Tj1Zi_451PHz0Meta } from "/app/cms_public/pages/athletics/index.vue?macro=true";
import { default as index2K9oYQ0jiczjfx4sTrBFcGIVEKsbQ2_W_wYg_WzMs1QMeta } from "/app/cms_public/pages/documents/index.vue?macro=true";
import { default as index0N_aqUe5O1VhpNl_U10vC8V_45IOrNSBXiZbVrQiUrvCQMeta } from "/app/cms_public/pages/live-feed/index.vue?macro=true";
import { default as indexn6A_45gilsCTha5q13ESovZimi9KIl0Cs2G9b0Dpv0JtwMeta } from "/app/cms_public/pages/browse/[id]/index.vue?macro=true";
import { default as indexIZTiZ1NMoslWTlNUQ6UlgIZJIXJs0LzVYCkgILqHNXAMeta } from "/app/cms_public/pages/page/[slug]/index.vue?macro=true";
import { default as indexgesherpLBWTTUwTSbWz4vbukmvyoRszLtGMsJACrSA0Meta } from "/app/cms_public/pages/article/[id]/index.vue?macro=true";
import { default as _91_46_46_46slug_93JBkZfkh8M9BMtW1t6kYsvDHsll9mjzJz6r0rDpfNfq8Meta } from "/app/cms_public/pages/documents/[...slug].vue?macro=true";
import { default as indexSFKl82Y9U9_L3m_45YS_wO17W7OdnxR45p92Qi_WIs4D4Meta } from "/app/cms_public/pages/intranet/login/index.vue?macro=true";
import { default as _91_91uuid_93_93d40zQIpdBMGY5D_45_45MXyhX_gSORJomdNOaYx7g1po_45aYMeta } from "/app/cms_public/pages/forms/[[id]]/[[uuid]].vue?macro=true";
import { default as indext2FasbQauQ3FFRGMjQiJ_45tYPH_G3LfH4oYnpAPnAP0IMeta } from "/app/cms_public/pages/live_feeds/[id]/index.vue?macro=true";
import { default as indexcJPbtnIAXwpPukiTb_ZNq5aqkDb93UPVoURzECwn_cMMeta } from "/app/cms_public/pages/page-preview/[slug]/index.vue?macro=true";
import { default as indexbawQaf5J0o64esZ_45qMog6Dc7uM_458tPbWmgoH2wXtDAwMeta } from "/app/cms_public/pages/preview/[token]/[id]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/cms_public/pages/index.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/app/cms_public/pages/news/index.vue")
  },
  {
    name: "staff",
    path: "/staff",
    component: () => import("/app/cms_public/pages/staff/index.vue")
  },
  {
    name: "dining",
    path: "/dining",
    component: () => import("/app/cms_public/pages/dining/index.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/app/cms_public/pages/events/index.vue")
  },
  {
    name: "athletics",
    path: "/athletics",
    component: () => import("/app/cms_public/pages/athletics/index.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/app/cms_public/pages/documents/index.vue")
  },
  {
    name: "live-feed",
    path: "/live-feed",
    component: () => import("/app/cms_public/pages/live-feed/index.vue")
  },
  {
    name: "browse-id",
    path: "/browse/:id()",
    meta: indexn6A_45gilsCTha5q13ESovZimi9KIl0Cs2G9b0Dpv0JtwMeta || {},
    component: () => import("/app/cms_public/pages/browse/[id]/index.vue")
  },
  {
    name: "page-slug",
    path: "/page/:slug()",
    meta: {"middleware":["page-content"]},
    component: () => import("/app/cms_public/pages/page/[slug]/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/app/cms_public/pages/article/[id]/index.vue")
  },
  {
    name: "documents-slug",
    path: "/documents/:slug(.*)*",
    component: () => import("/app/cms_public/pages/documents/[...slug].vue")
  },
  {
    name: "intranet-login",
    path: "/intranet/login",
    meta: { ...(indexSFKl82Y9U9_L3m_45YS_wO17W7OdnxR45p92Qi_WIs4D4Meta || {}), ...{"middleware":["intranet-roles"]} },
    component: () => import("/app/cms_public/pages/intranet/login/index.vue")
  },
  {
    name: "forms-id-uuid",
    path: "/forms/:id?/:uuid?",
    component: () => import("/app/cms_public/pages/forms/[[id]]/[[uuid]].vue")
  },
  {
    name: "live_feeds-id",
    path: "/live_feeds/:id()",
    component: () => import("/app/cms_public/pages/live_feeds/[id]/index.vue")
  },
  {
    name: "page-preview-slug",
    path: "/page-preview/:slug()",
    meta: {"middleware":["page-preview-auth"]},
    component: () => import("/app/cms_public/pages/page-preview/[slug]/index.vue")
  },
  {
    name: "preview-token-id",
    path: "/preview/:token()/:id()",
    meta: {"middleware":["preview-auth"]},
    component: () => import("/app/cms_public/pages/preview/[token]/[id]/index.vue")
  },
  {
    name: "alias-index",
    path: "/o/:alias/",
    component: () => import("/app/cms_public/pages/index.vue")
  },
  {
    name: "alias-news",
    path: "/o/:alias/news",
    component: () => import("/app/cms_public/pages/news/index.vue")
  },
  {
    name: "alias-staff",
    path: "/o/:alias/staff",
    component: () => import("/app/cms_public/pages/staff/index.vue")
  },
  {
    name: "alias-dining",
    path: "/o/:alias/dining",
    component: () => import("/app/cms_public/pages/dining/index.vue")
  },
  {
    name: "alias-events",
    path: "/o/:alias/events",
    component: () => import("/app/cms_public/pages/events/index.vue")
  },
  {
    name: "alias-athletics",
    path: "/o/:alias/athletics",
    component: () => import("/app/cms_public/pages/athletics/index.vue")
  },
  {
    name: "alias-documents",
    path: "/o/:alias/documents",
    component: () => import("/app/cms_public/pages/documents/index.vue")
  },
  {
    name: "alias-live-feed",
    path: "/o/:alias/live-feed",
    component: () => import("/app/cms_public/pages/live-feed/index.vue")
  },
  {
    name: "alias-browse-id",
    path: "/o/:alias/browse/:id()",
    meta: indexn6A_45gilsCTha5q13ESovZimi9KIl0Cs2G9b0Dpv0JtwMeta || {},
    component: () => import("/app/cms_public/pages/browse/[id]/index.vue")
  },
  {
    name: "alias-page-slug",
    path: "/o/:alias/page/:slug()",
    meta: {"middleware":["page-content"]},
    component: () => import("/app/cms_public/pages/page/[slug]/index.vue")
  },
  {
    name: "alias-article-id",
    path: "/o/:alias/article/:id()",
    component: () => import("/app/cms_public/pages/article/[id]/index.vue")
  },
  {
    name: "alias-documents-slug",
    path: "/o/:alias/documents/:slug(.*)*",
    component: () => import("/app/cms_public/pages/documents/[...slug].vue")
  },
  {
    name: "alias-intranet-login",
    path: "/o/:alias/intranet/login",
    meta: { ...(indexSFKl82Y9U9_L3m_45YS_wO17W7OdnxR45p92Qi_WIs4D4Meta || {}), ...{"middleware":["intranet-roles"]} },
    component: () => import("/app/cms_public/pages/intranet/login/index.vue")
  },
  {
    name: "alias-forms-id-uuid",
    path: "/o/:alias/forms/:id?/:uuid?",
    component: () => import("/app/cms_public/pages/forms/[[id]]/[[uuid]].vue")
  },
  {
    name: "alias-live_feeds-id",
    path: "/o/:alias/live_feeds/:id()",
    component: () => import("/app/cms_public/pages/live_feeds/[id]/index.vue")
  },
  {
    name: "alias-page-preview-slug",
    path: "/o/:alias/page-preview/:slug()",
    meta: {"middleware":["page-preview-auth"]},
    component: () => import("/app/cms_public/pages/page-preview/[slug]/index.vue")
  },
  {
    name: "alias-preview-token-id",
    path: "/o/:alias/preview/:token()/:id()",
    meta: {"middleware":["preview-auth"]},
    component: () => import("/app/cms_public/pages/preview/[token]/[id]/index.vue")
  }
]